import type { CopyShape } from "@tami/core/intl";

import type { PLAN_PRESENTATION_COPY_PT_BR } from "../plan-presentation.copy";

export const PLAN_PRESENTATION_COPY_EN_US: CopyShape<typeof PLAN_PRESENTATION_COPY_PT_BR> = {
  fallbackPitchFree: "Free access to the core features. No surprises — and no card.",
  fallbackPitchPaid: "The whole product, without the free plan's limits.",
  badge: {
    onRequest: "Tailor-made",
    free: "100% Free",
    highlighted: "Way more Tãmi",
    default: "No limits",
  },
  ctaFree: "Start free now!",
  ctaSubscribe: (shortPlanName: string): string => `Get ${shortPlanName}`,
};
